import { render, staticRenderFns } from "./practiceBase.vue?vue&type=template&id=d6b0e5fa&scoped=true"
import script from "./practiceBase.vue?vue&type=script&lang=js"
export * from "./practiceBase.vue?vue&type=script&lang=js"
import style0 from "./practiceBase.vue?vue&type=style&index=0&id=d6b0e5fa&prod&scoped=scoped&lang=scss"
import style1 from "./practiceBase.vue?vue&type=style&index=1&id=d6b0e5fa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6b0e5fa",
  null
  
)

export default component.exports